<template>
    <div class="hk-background">
        <img src="@images/base/login-bg.jpg" class="hk-background-img" alt="" />
        <div class="hk-background-text">
            <router-link to="/">
                <img src="@images/logo.png" class="logo" alt="" />
            </router-link>
            <h1 class="title">巴蜀51好课</h1>
            <!-- <ul class="criterion">
                <li class="criterion-item">教育以人为本</li>
                <li class="criterion-item">校长以老师为本</li>
                <li class="criterion-item">教师以学生为本</li>
            </ul>
            <el-divider direction="vertical"></el-divider> -->
            <div class="copyright">
                <p class="telephone flex">
                    <span>重庆市巴蜀中学校</span><span>招生咨询电话：023-63002629</span>
                </p>
                <p class="copyright-text flex">
                    <span>版权所有</span><span>巴蜀中学</span><span>渝ICP备11004221</span
                    ><span>渝公网安备</span><span>50010302000290号</span>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
    created() {},
    mounted() {}
};
</script>
<style lang="scss" scoped>
/* @import url(); 引入css类 */
.hk-background {
    width: 100%;
    height: 100%;
    position: absolute;
    overflow: hidden;
    &-img {
        width: 100%;
        height: 100%;
        position: absolute;
        object-fit: cover;
        object-position: center;
    }
    &-text {
        position: absolute;
        top: 45px;
        left: 312px;
        bottom: 0;
        z-index: 22;
        .logo {
            width: 121px;
            height: 40px;
            margin-bottom: 105px;
            cursor: pointer;
        }
        .title {
            font-size: 42px;
            font-family: Source Han Sans SC;
            font-weight: bold;
            color: #292a25;
            margin-bottom: 54px;
        }
        .criterion-item {
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #888a87;
            margin-bottom: 20px;
        }
        &::v-deep {
            .el-divider--vertical {
                min-height: 271px;
                background: #c0b0c1;
                margin-bottom: 38px;
            }
        }
        .copyright {
            position: absolute;
            bottom: 20px;
            left: 0;
            width: 800px;
            p {
                span {
                    font-size: 16px;
                    font-family: PingFang SC;
                    font-weight: 500;
                    color: #888a87;
                    line-height: 30px;
                    margin-right: 10px;
                }
            }
        }
    }
}
</style>
